export default __webpack_public_path__ + "static/media/Online payment_Isometric.bb5fa92d.svg";